var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { getZohoAuthenticationUri } from '@/clients/crm';
import Modal from 'components/Modal.vue';
import Tooltip from 'components/Tooltip.vue';
import CrmCardContent from 'components/CrmCardContent.vue';
import { NotificationService } from '@/services/NotificationService';
let ZohoConfigCard = class ZohoConfigCard extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.openModal = false;
        this.crmIcon = 'statics/images/zohocrm.png';
        this.companyFields = [
            'Razão Social/Nome Fantasia',
            'CNPJ',
            'Setor',
            'Endereço',
            'Cnae Primário',
            'Cnae Secundário',
            'Data de Abertura',
            'Faixa de Faturamento da Unidade CNPJ',
            'Faixa de Faturamento da Empresa',
            'Faixa de Funcionários da Unidade CNPJ',
            'Faixa de Funcionarios da Empresa',
            'Natureza Jurídica',
            'Administrador',
            'Facebook',
            'Website',
            'Todos os Emails',
            'Todos os Telefones',
            'Decisores',
            'Situação',
            'Nome do Administrador',
            'Capital Social',
            'Emails Principais',
            'Telefones Principais',
        ];
        this.decisorFields = [
            'Nome',
            'E-mail',
            'Cargo',
            'Endereço',
            'Departamento',
            'Nível de decisão',
        ];
        this.questions = [
            {
                question: 'Quais planos permitem exportação?',
                answer: 'Profissional, Empresa ou O MELHOR.',
            },
            {
                question: 'Qual nível de permissão meu usuário precisa ter?',
                answer: 'Superadministrador ou usuário que possa criar e editar empresas e contatos.',
            },
            {
                question: 'Onde encontrar os dados das empresas?',
                answer: 'No menu superior e clica em Contas.',
            },
            {
                question: 'Onde encontrar os dados dos decisores?',
                answer: 'No menu superior e clica em Contatos.',
            },
            {
                question: 'O que acontece se eu exportar 2 vezes a mesma empresa?',
                answer: 'Nosso integrador irá duplicar a empresa e seus contatos no crm',
            },
        ];
    }
    get tutorialVideoLink() {
        return 'https://share.vidyard.com/watch/YDFq8SumNj2BwiDiuAJwmU';
    }
    async handleBtnClick() {
        this.loading = true;
        try {
            const redirect_uri = `${window.location.origin}/crm/zoho/callback`;
            const response = await getZohoAuthenticationUri({
                redirect_uri,
            });
            window.open(response.data.uri, 'popup', 'height=600,width=400');
        }
        catch (e) {
            NotificationService.error('Error', 'Não foi possível gerar a janela de autenticação');
        }
        this.loading = false;
    }
};
ZohoConfigCard = __decorate([
    Component({
        name: 'ZohoConfigCard',
        components: {
            Modal,
            Tooltip,
            CrmCardContent,
        },
    })
], ZohoConfigCard);
export default ZohoConfigCard;
